module.exports = __webpack_public_path__ + "static/media/watermelon.895af42d.jpg";